import WpLogin from "@/ts/base/WpLogin";

new WpLogin();
